<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalConfirmation } from '@shared/ui/modals'

import { useModalDuplicateAssignmentTemplate } from '../../../model/assignments/modal-duplicate-assignment-template.hook'

defineOptions({
  name: 'ModalDuplicateAssignmentTemplate',
})

const {
  refIsOpen,
  refIsLoading,
  refDetail,
  closeModal,
  confirmDuplicate,
} = useModalDuplicateAssignmentTemplate()
</script>

<template>
  <ModalConfirmation
    :show="refIsOpen"
    :loading="refIsLoading"
    :disabled="refIsLoading"
    mode="confirm"
    title="Duplicate assignment template"
    button-title="Duplicate"
    is-close-icon
    @click:confirm="confirmDuplicate"
    @click:cancel="closeModal"
  >
    <!-- Through the slot, not `detail`, which renders with `v-html` — see the delete modal. -->
    <template #content>
      <AppText
        name="body1"
        color="slate-700"
      >
        {{ refDetail }}
      </AppText>
    </template>
  </ModalConfirmation>
</template>
